import axiosInstance from '../../core/axiosConfig';
import { adminEventHandlers } from '../../hooks/useAdminEvents';

interface OrderAdminSummary {
  id: number;
  orderNumber: string;
  locationName: string;
  status: string;
  cancellationReason: 'NO_COURIER_FOUND' | 'COURIER_DID_NOT_PICK_UP' | null;
}

/* Problem z dostawa Wolt (tasks/wolt_update.md, B2/B3): zamowienie anulowane ze zwrotem.
   Zdarzenie niesie tylko id - numer i powod dociagamy przez REST z kontrola dostepu. */
adminEventHandlers.ORDER_DELIVERY_PROBLEM = async (event) => {
  const { data: order } = await axiosInstance.get<OrderAdminSummary>(
    `order/admin-summary/${event.entityId}`,
  );

  return {
    id: `ORDER_DELIVERY_PROBLEM-${event.entityId}`,
    messageKey: `adminEvents.deliveryProblem.${order.cancellationReason ?? 'UNKNOWN'}`,
    params: { number: order.orderNumber },
  };
};
